#import "../DepartmentFields.graphql"
query Departments(
  $orderBy: [DepartmentsOrderBy!]
  $first: Int
  $after: Cursor
  $filter: DepartmentFilter
) {
  departments(
    first: $first
    orderBy: $orderBy
    filter: $filter
    after: $after
  ) {
    nodes {
      ...DepartmentFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    totalCount
  }
}
